import { initialState, CollectionsState } from './selectors';
import * as actions from './actions';

export default (
  state: CollectionsState = initialState,
  action: actions.CollectionsAction,
) => {
  switch (action.type) {
    case actions.COLLECTIONS_ACTIONS.REQUESTED: {
      return { ...state, loading: true };
    }

    case actions.COLLECTIONS_ACTIONS.SUCCEEDED: {
      const {
        payload: { collections },
      } = action as actions.CollectionsSucceeded;

      return { ...state, collections, loading: false };
    }

    case actions.REMOVE_COLLECTION_ACTIONS.REQUESTED: {
      return { ...state, loading: true };
    }

    case actions.REMOVE_COLLECTION_ACTIONS.SUCCEEDED: {
      const {
        payload: { collectionId },
      } = action as actions.RemoveCollectionSucceeded;

      const collections = state.collections.filter(
        (collection: any) => collection.id.toString() !== collectionId,
      );

      return { ...state, collections, loading: false };
    }

    case actions.CREATE_COLLECTION_ACTIONS.REQUESTED: {
      return { ...state, loading: true };
    }

    case actions.CREATE_COLLECTION_ACTIONS.FAILED: {
      return { ...state, loading: false };
    }

    case actions.CREATE_COLLECTION_ACTIONS.SUCCEEDED: {
      const {
        payload: { collection },
      } = action as actions.CreateCollectionSucceeded;

      const collections = state.collections.filter(
        item => item.id !== collection.id,
      );

      return {
        ...state,
        loading: false,
        collections: [collection, ...collections],
      };
    }

    case actions.EDIT_COLLECTION_ACTIONS.REQUESTED: {
      return { ...state, loading: true };
    }

    case actions.EDIT_COLLECTION_ACTIONS.FAILED: {
      return { ...state, loading: false };
    }

    case actions.EDIT_COLLECTION_ACTIONS.SUCCEEDED: {
      const {
        payload: { collection },
      } = action as actions.EditCollectionSucceeded;

      const collections = state.collections.filter(
        item => item.id !== collection.id,
      );

      return {
        ...state,
        loading: false,
        collections: [collection, ...collections],
      };
    }

    case actions.SET_EDIT_COLLECTION_ACTIONS.SELECT: {
      const {
        payload: { collection },
      } = action as any;

      return { ...state, editCollection: collection };
    }

    case actions.SET_EDIT_COLLECTION_ACTIONS.REMOVE: {
      return { ...state, editCollection: initialState.editCollection };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/scenes/Collections/services/reducer.ts